import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import MapView from "./mapView";
import WebView from "./webView";
import { SearchRoute } from "../../Apis/routeTrackingApi";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import { TableLoader } from "../../Common/ShimmerLoader";
import { GetRoute } from "../../Apis/routeMasterApi";
import Select from "react-select";
import AsyncSelectNew from "react-select";
import { Controller, useForm } from "react-hook-form";
import isGHMC from "../../Common/helper/helpar";

function RouteTracking() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [shiftData, setShiftData] = useState([]);
  const [routeData, setRouteData] = useState([]);
  const [routeListValue, setRouteListValue] = useState();
  const [routeOptions, setRouteOptions] = useState([]);
  const [isLoadingRoutes, setIsLoadingRoutes] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const isProd = isGHMC();
  const fetchShiftData = async () => {
    try {
      const response = await AllShiftMaster();
      setShiftData(response);
      // console.log(response, 'shift response from route tracking')
    } catch (error) {
      console.log(error);
    }
  };
  const fetchRouteData = async () => {
    try {
      const response = await GetRoute()
        // setRouteData(response.data);
        .then((response) => {
          const arrayrouteId = response.data.map((item) => ({
            label: item.routeCode,
            value: item.routeId,
          }));
          setRouteData(arrayrouteId);
        });
      // console.log(response.data, 'route response from route tracking')
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchShiftData();
    fetchRouteData();
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(handleSearchApi);
    }
  };

  const handleSearchApi = async (data) => {
    setIsLoadingData(true);
    try {
      // const routeId = data.routeId != null ? data.routeId : '';

      const requestData = {
        routeId: watch("routeId"),
        // routeId,
        ShiftValue: watch("ShiftValue"),
        date: watch("date"),
      };
      const response = await SearchRoute(requestData, requestData.routeId, requestData.ShiftValue, requestData.date);
      setRouteOptions(response);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingData(false);
    }
  };



  return (
    <>
      {/* tabs */}
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
          <h4 class="text-start mb-3"> Route Tracking </h4>
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <form
                    onSubmit={handleSubmit(handleSearchApi)}
                    onKeyDown={(e) => {
                      handleKeyDown(e, handleSubmit);
                    }}
                  >
                    <div className="row align-items-end" style={{ textAlign: "left" }}>
                      <div className="col-md-3">
                        <label>Select Date</label>
                        <input
                          className="form-control"
                          type="date"
                          {...register("date", { required: true })}
                          name="date"
                          defaultValue={new Date().toISOString().split("T")[0]}
                          style={{ backgroundColor: "#fff" }}
                        />
                        {errors.date && (
                          <span>
                            <p className="mt-2" style={{ color: 'red' }}>
                              {" "}
                              Date is required
                            </p>
                          </span>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label>Select Shift</label>
                        <select
                          className="form-select"
                          {...register("ShiftValue", { required: true })}
                          name="ShiftValue"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <option value="">--Select--</option>
                          {shiftData.map((shift) => (
                            <option
                              key={shift.shiftId}
                              value={shift.shiftId}
                            >
                              {shift.shiftName}
                            </option>
                          ))
                          }
                        </select>
                        {errors.ShiftValue && (
                          <span>
                            <p className="mt-2" style={{ color: 'red' }}>
                              {" "}
                              Shift is required
                            </p>
                          </span>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label>Select Route</label>
                        <Controller
                          name="routeId"
                          control={control}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <AsyncSelectNew
                              {...field}
                              isClearable={true}
                              placeholder="--Select--"
                              name="routeId"
                              options={routeData}
                              value={routeListValue}
                              onChange={(selectedOption) => {
                                setRouteListValue(selectedOption);
                                field.onChange(selectedOption ? selectedOption.value : null);
                              }}
                            />
                          )}
                        />
                        {/* <select
                          className="form-select"
                          {...register("routeId", { required: true })}
                          name="routeId"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <option value="">--Select--</option>
                          {routeData.map((route) => (
                            <option
                              key={route.routeId}
                              value={route.routeId}
                            >
                              {route.routeCode}
                            </option>
                          ))
                          }
                        </select> */}
                        {errors.routeId && (
                          <span>
                            <p className="mt-2" style={{ color: 'red' }}>
                              {" "}
                              Route is required
                            </p>
                          </span>
                        )}
                      </div>
                      <div className="col-md-3 ms-auto ">
                        <button  type="submit"  className={`btn mt-4  ${isProd ? "search-ghmc" : "search-swm"}`}>
                          Search
                        </button>
                      </div>
                    </div>

                  </form>
               

              {/* Tabs for Map view and Web view */}
              {/* {isOptionsLoading && <TableLoader height={500} />} */}
              {isLoadingData ? (
                <TableLoader height={500} />
              ) : (
                <Tabs
                  selectedIndex={selectedTab}
                  onSelect={(index) => setSelectedTab(index)}
                  style={{ textAlign: "start" }}
                  className='mt-3'
                >
                  <TabList style={{display: "flex" }} className='route_tabs' >
                    <Tab 
                     className={`route_tabsnew ${isProd
                      ? selectedTab === 0
                        ? "active-ghmc"
                        : "active-swm"
                      : selectedTab === 0
                        ? "active-default"
                        : "inactive-default"
                    }`}
                    >Web View</Tab>
                    <Tab
                    className={`route_tabsnew ${isProd
                      ? selectedTab === 1
                        ? "active-ghmc"
                        : "active-swm"
                      : selectedTab === 1
                        ? "active-default"
                        : "inactive-default"
                    }`}
                    >Map View</Tab>
                  </TabList>

                  {/* Web View Tab */}
                  <TabPanel>
                    <WebView
                      isLoadingData={isLoadingData}
                      setIsLoadingData={setIsLoadingData}
                      routeOptions={routeOptions}
                      handleSearchApi={handleSearchApi}
                    />
                  </TabPanel>
                  {/* Map View Tab */}
                  <TabPanel>
                    <MapView
                      routeOptions={routeOptions}
                    />
                  </TabPanel>
                </Tabs>
              )}
            </div>
          </div>
        </div>
         </div>
              </div>
      </div>
    </>
  );
}

export default RouteTracking;